import React from 'react'
import { BlogSingle } from '../../pages';
import { useNavigate, useParams } from 'react-router-dom';
import { blogContent } from '../../utils/blog';
import constant from '../../utils/constant';


const BlogSingleContainer = () => {
  const { id } = useParams();
  const post = blogContent.filter((x) => {
    return x.link === `/blog/${id}`
  });

  const blogPost = post[0];

  const allRelatedPost = blogContent.filter((x) => {
    return blogPost.tags.some(element => x.tags.includes(element))
  });

  const relatedPost = allRelatedPost.filter((x) => {
    return x._id !== blogPost._id
  }).sort(() => 0.5 - Math.random()).slice(0, 3);

  const navigate = useNavigate();

  const switchToSignup = () => {
    navigate(constant.Routes.SignUp);
  };


  return (
    <BlogSingle blogPost={blogPost} relatedPost={relatedPost} switchToSignup={switchToSignup} />
  )
}

export default BlogSingleContainer